import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
import StudioBuilder from './StudioBuilder';

const StudioBuilderPage = () => {
  const [showBuilder, setShowBuilder] = useState(false);

  return (
    <div className="min-h-screen bg-obsidian flex flex-col">
      {/* Minimal header */}
      <header className="border-b border-white/10 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="studio-page-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_7622ca65-87c5-425f-ac54-f38f9958c6c6/artifacts/zd4sl0r2_Logo%202.png"
            alt="Kingdom V.I.B.E. Studios"
            className="h-10 w-auto"
          />
        </Link>
        <Link
          to="/"
          className="text-xs text-white/40 hover:text-amber-400 transition-colors flex items-center gap-1"
          data-testid="studio-page-visit-site"
        >
          Visit our site
          <ArrowRight size={12} />
        </Link>
      </header>

      {/* Hero / Landing area */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        {!showBuilder ? (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-2xl"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_7622ca65-87c5-425f-ac54-f38f9958c6c6/artifacts/zd4sl0r2_Logo%202.png"
              alt="Kingdom V.I.B.E. Studios"
              className="h-80 sm:h-96 w-auto mx-auto mb-6"
            />

            <div className="flex items-center justify-center gap-2 mb-6">
              <Sparkles className="w-5 h-5 text-amber-400" />
              <span className="font-mono text-xs sm:text-sm uppercase tracking-widest text-amber-400">AI-Powered Studio Design</span>
              <Sparkles className="w-5 h-5 text-amber-400" />
            </div>

            <h1
              className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold uppercase text-white mb-4 leading-tight"
              data-testid="studio-page-heading"
            >
              Design Your <span className="text-amber-400" style={{ textShadow: '0 0 30px rgba(251, 191, 36, 0.4)' }}>Dream Studio</span>
            </h1>

            <p className="text-base sm:text-lg text-white/60 mb-8 max-w-lg mx-auto leading-relaxed">
              Upload your space, choose your setup, and watch AI transform it into a professional production studio in seconds.
            </p>

            <button
              onClick={() => setShowBuilder(true)}
              className="btn-neon btn-neon-gold inline-flex items-center gap-2 text-sm sm:text-base px-8 py-4"
              data-testid="studio-page-start-btn"
            >
              <Sparkles size={18} />
              <span>Build Your Studio Concept</span>
            </button>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md mx-auto">
              {[
                { num: '01', label: 'Upload your space or start fresh' },
                { num: '02', label: 'Pick type, level & style' },
                { num: '03', label: 'Get your AI studio concept' },
              ].map((item) => (
                <div key={item.num} className="text-center">
                  <span className="font-mono text-xs text-amber-400/60 block mb-1">{item.num}</span>
                  <p className="text-xs text-white/40">{item.label}</p>
                </div>
              ))}
            </div>
          </motion.div>
        ) : null}
      </div>

      {/* Studio Builder Modal */}
      <StudioBuilder isOpen={showBuilder} onClose={() => setShowBuilder(false)} />

      {/* Minimal footer */}
      <footer className="border-t border-white/10 px-6 py-3 text-center">
        <p className="text-xs text-white/30">
          Kingdom V.I.B.E. Studios — Summerville, SC
        </p>
      </footer>
    </div>
  );
};

export default StudioBuilderPage;
